import { NavLink } from "react-router-dom";
import { useT } from "../i18n";

/** Thanh tab chung cho nhóm trang Cẩm nang. */
export function GuideTabs() {
  const t = useT();
  const cls = ({ isActive }: { isActive: boolean }) => (isActive ? "active" : undefined);
  return (
    <nav className="tabs" aria-label={t("Cẩm nang", "Guide")}>
      <NavLink to="/guide" end className={cls}>{t("Thể thức & chính sách", "Format & policies")}</NavLink>
      <NavLink to="/glossary" className={cls}>{t("Thuật ngữ", "Glossary")}</NavLink>
      <NavLink to="/resources" className={cls}>{t("Tài liệu chính thức", "Official resources")}</NavLink>
    </nav>
  );
}
